module.exports = __webpack_public_path__ + "img/item4.f9edf2e4.png";